import { gql } from '@/__generated__';

export const deleteProductDocument = gql(/* GraphQL */ `
  mutation DeleteProduct($where: ProductWhereUniqueInput!) {
    deleteProduct(where: $where) {
      id
    }
  }
`);
